import type { ComputedRef } from "vue";
import { computed } from "vue";

import { useUserSettingsStore } from "@/store/userSettings";

/**
 * Persists expand/collapse state per tree node (tenant or organization id) so the tree
 * reopens the way the user left it. `defaultExpanded` only applies until the user has
 * explicitly toggled that node at least once.
 */
export function useTreeItemExpanded(nodeId: ComputedRef<string>, defaultExpanded: ComputedRef<boolean>) {
  const userSettings = useUserSettingsStore();

  const expanded = computed(() => userSettings.tenantOrgTreeExpanded[nodeId.value] ?? defaultExpanded.value);

  const toggle = () => {
    void userSettings.setTenantOrgTreeExpanded({
      ...userSettings.tenantOrgTreeExpanded,
      [nodeId.value]: !expanded.value,
    });
  };

  return { expanded, toggle };
}
